import { useGetStudy, useUpdateStudy } from "@/api/studio/studies/queries";
import { useEffect } from "react";

/*
 * useUpdateRoute hook
 * Updates the route of a study without a toast notification
 * This is called through-out the study flow for each important
 * step so the user can return if they navigate away
 */
export const useUpdateRoute = (projectId: string, studyId: string, route: string) => {
  /* Queries */
  const { data: studyDetails } = useGetStudy(projectId, studyId);
  const { mutateAsync: updateStudy } = useUpdateStudy();

  /* Side effects */
  useEffect(() => {
    if (studyDetails) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { contextPackIds: _contextPackIds, ...studyDetailsWithoutContextPackIds } = studyDetails;
      updateStudy({ studyId, projectId, backgroundUpdate: true, values: { ...studyDetailsWithoutContextPackIds, route: route } });
    }
  }, [studyDetails, studyId, projectId, updateStudy, route]);
};
